import React, { useState, useEffect } from "react";
import { Bars3, Moon, Sun, XMark } from "../../assets/icons";
import logo from "../../assets/images/logo.png";
interface iNavTopProps extends React.HTMLProps<HTMLDivElement> {}

const NavTop: React.FC<iNavTopProps> = (props) => {
  // const { className } = props;
  const [isShowNav, setIsShowNav] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [yOffset, setYOffset] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(false);

  const navItems = [
    { id: "aboutMeId", label: "Home" },
    { id: "assistantId", label: "Assistant" },
    { id: "techSkillId", label: "About" },
    { id: "workExpId", label: "Work" },
    { id: "contactId", label: "Contact" },
  ];

  useEffect(() => {
    const menu = document.getElementById("menu-responsive");
    if (menu) {
      if (isShowNav === false) {
        menu.style.top = `-100%`;
      } else {
        menu.style.top = `${0}px`;
      }
    }
  }, [isShowNav]);
  useEffect(() => {
    function handleScroll() {
      const currentYOffset = window.scrollY;
      let visible;
      if (currentYOffset < 64) visible = false;
      else visible = yOffset < currentYOffset;
      setYOffset(window.scrollY);
      setVisible(visible);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [yOffset]);
  useEffect(() => {
    if (isDarkMode === true) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
  }, [isDarkMode]);

  const scrollToTopById = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      let y = element.getBoundingClientRect().top + window.scrollY;
      // Scroll below to top -> Nav overlap title, so we will move 64px - that's nav's height
      if (element.getBoundingClientRect().top <= window.scrollY) y = y - 64;
      window.scrollTo({ top: y, behavior: "smooth" });
      setIsShowNav(false);
    }
  };
  return (
    <nav
      className={
        "w-full flex justify-between fixed z-50 items-center bg-pri bg-white bg-opacity-95  px-[5%] h-16 border-b-[1px]  border-solid border-gray-200  dark:bg-bgDark dark:border-[rgb(255,251,251,0.1)] dark:bg-opacity-[0.98] duration-300" +
        (visible ? "  -top-16 " : " top-0 ")
      }
    >
      <div
        id="menu-responsive"
        className={
          "fixed w-screen h-screen bg-bgLight dark:bg-bgDark   duration-500 transition-all " +
          (!isShowNav ? ` -top-[100%] left-0 ` : " top-0 left-0")
        }
      >
        <button
          className="p-1 absolute top-4 right-9 text-bgDark dark:text-white"
          onClick={(e) => {
            e.stopPropagation();
            setIsShowNav(false);
          }}
        >
          <XMark />
        </button>
        <div
          className={"flex flex-col  gap-4 mt-16  text-bgDark dark:text-white"}
        >
          {navItems.map((item) => (
            <button
              key={item.id}
              className="px-3 py-2 w-full  font-medium rounded-md flex-1"
              onClick={() => {
                scrollToTopById(item.id);
              }}
            >
              {item.label}
            </button>
          ))}
          <button
            className=" px-3 py-2 w-full flex justify-center"
            onClick={() => {
              setIsDarkMode(!isDarkMode);
              setIsShowNav(false);
            }}
          >
            <i className="text-primary">{isDarkMode ? <Moon /> : <Sun />}</i>
          </button>
        </div>
      </div>
      <a className=" flex items-center justify-center   h-full px-2" href="/">
        <img src={logo} className=" w-14 " alt="Logo" />
      </a>
      <div
        className="phone:flex hidden flex-1  justify-end "
        onClick={() => setIsShowNav(true)}
      >
        <button className=" p-2">
          <Bars3 />
        </button>
      </div>
      <div className={"flex items-center gap-4 phone:hidden"}>
        {navItems.map((item) => (
          <button
            key={item.id}
            className="px-3 py-2  font-medium rounded-md"
            onClick={() => {
              scrollToTopById(item.id);
            }}
          >
            {item.label}
          </button>
        ))}
        <p className="">|</p>
        <button
          className=" px-3 py-2 w-full "
          onClick={() => {
            setIsDarkMode(!isDarkMode);
          }}
        >
          <i className="text-primary">{isDarkMode ? <Moon /> : <Sun />}</i>
        </button>
      </div>
    </nav>
  );
};

export default NavTop;
